/**
 * Gerador de mensagem padronizada de WhatsApp para o Super Lazinho Avenida 7
 */

import { formatCurrency } from './formatters.js';

export function buildWhatsAppMessage(orderData, storeInfo) {
  const {
    customerName,
    phone,
    orderType, // "delivery" | "pickup"
    address,
    reference,
    paymentMethod, // "pix" | "dinheiro" | "cartao_debito" | "cartao_credito"
    changeFor,
    generalNotes,
    cartItems,
    subtotal,
    deliveryFee,
    total
  } = orderData;

  const lines = [];

  lines.push("🍽️ *PEDIDO — SUPER LAZINHO AVENIDA 7*");
  lines.push("━━━━━━━━━━━━━━━━━━━━━");
  lines.push("");
  lines.push(`👤 *Cliente:* ${customerName.trim()}`);
  if (phone && phone.trim()) {
    lines.push(`📱 *Telefone de contato:* ${phone.trim()}`);
  }
  lines.push(`📍 *Tipo de pedido:* ${orderType === "delivery" ? "🛵 Entrega" : "🛍️ Retirada no balcão"}`);

  if (orderType === "delivery") {
    lines.push(`🏠 *Endereço:* ${address.trim()}`);
    if (reference && reference.trim()) {
      lines.push(`🚩 *Ponto de referência:* ${reference.trim()}`);
    }
  }

  lines.push("");
  lines.push("📋 *ITENS DO PEDIDO:*");
  lines.push("─────────────────────");

  cartItems.forEach((item, index) => {
    lines.push(`*${item.quantity}x ${item.name}*`);

    // Detalhes de configuração
    if (item.sizeName) {
      lines.push(`   ▫️ Tamanho: ${item.sizeName}`);
    }
    if (item.portionType) {
      lines.push(`   ▫️ Porção: ${item.portionType === 'meia' ? 'Meia porção (60%)' : 'Inteira'}`);
    }
    if (item.selectedMeat) {
      lines.push(`   🥩 Carne: ${item.selectedMeat}`);
    }
    if (item.selectedChoice1) {
      lines.push(`   ▫️ Acomp. 1: ${item.selectedChoice1}`);
    }
    if (item.selectedChoice2) {
      lines.push(`   ▫️ Acomp. 2: ${item.selectedChoice2}`);
    }
    if (item.selectedEdge) {
      lines.push(`   ▫️ Borda: ${item.selectedEdge}`);
    }
    if (item.selectedSauce) {
      lines.push(`   ▫️ Molho: ${item.selectedSauce}`);
    }
    if (item.flavor) {
      lines.push(`   ▫️ Sabor: ${item.flavor}`);
    }
    if (item.selectedAddons && item.selectedAddons.length > 0) {
      const addonsStr = item.selectedAddons.map(a => `${a.name} (+${formatCurrency(a.price)})`).join(", ");
      lines.push(`   ➕ Adicionais: ${addonsStr}`);
    }
    if (item.notes && item.notes.trim()) {
      lines.push(`   💬 Obs: _"${item.notes.trim()}"_`);
    }

    if (item.pricePending) {
      lines.push(`   💰 Subtotal: *Preço sob confirmação*`);
    } else {
      lines.push(`   💰 Subtotal: *${formatCurrency(item.totalPrice)}*`);
    }
    lines.push("");
  });

  lines.push("─────────────────────");
  lines.push(`💵 *Subtotal:* ${formatCurrency(subtotal)}`);
  lines.push(`🛵 *Taxa de entrega:* ${deliveryFee !== null ? formatCurrency(deliveryFee) : "A DEFINIR"}`);
  lines.push(`🧾 *TOTAL DO PEDIDO:* *${formatCurrency(total)}*`);
  lines.push("");

  // Pagamento
  let paymentText = "";
  if (paymentMethod === "pix") {
    paymentText = "Pix manual (enviar chave na conversa)";
  } else if (paymentMethod === "dinheiro") {
    if (changeFor && Number(changeFor) > 0) {
      paymentText = `Dinheiro (Troco para ${formatCurrency(Number(changeFor))})`;
    } else {
      paymentText = "Dinheiro (Sem necessidade de troco)";
    }
  } else if (paymentMethod === "cartao_debito") {
    paymentText = "Cartão na entrega (Débito)";
  } else if (paymentMethod === "cartao_credito") {
    paymentText = "Cartão na entrega (Crédito)";
  } else {
    paymentText = "A combinar";
  }

  lines.push(`💳 *Forma de pagamento:* ${paymentText}`);

  if (generalNotes && generalNotes.trim()) {
    lines.push(`📝 *Observações gerais:* ${generalNotes.trim()}`);
  }

  lines.push("");
  lines.push("━━━━━━━━━━━━━━━━━━━━━");
  lines.push("⚡ _Pedido gerado pelo STELLARI SERVE_");

  return lines.join("\n");
}

export function generateWhatsAppLink(phone, message) {
  const cleanPhone = phone ? phone.replace(/\D/g, '') : '';
  const encoded = encodeURIComponent(message);
  return `https://api.whatsapp.com/send?phone=${cleanPhone}&text=${encoded}`;
}
